export { default } from "./SliderPanel";
